import React from 'react';
import { useSelector } from 'react-redux';
import Button from '@shared-components/atoms/Button';
import { selectors } from '../../pizza/slice/pizza.slice';
import useDealValidator from '../hoc/useDealValidator/useDealValidator';
import useStyles from './styles';

import useAddToDeal from '../hooks/useAddToDeal';

type AddToDealButtonProps = {
  upchargeAmount?: number;
  variant: 'primary' | 'secondary';
};

const AddToDealButton = ({ upchargeAmount, variant }: AddToDealButtonProps): JSX.Element | null => {
  const buttonText = 'add to deal';
  const classes = useStyles();
  const pizza = useSelector(selectors.selectCartAddablePizza);
  const addToDeal = useAddToDeal();

  const showAddButton = useDealValidator();

  if (!showAddButton) {
    return null;
  }

  return (
    <Button
      data-testid="add-to-deal-button"
      variant={variant}
      onClick={() => addToDeal(pizza, false, upchargeAmount)}
      className={classes.button}
    >
      {buttonText}
    </Button>
  );
};

export default AddToDealButton;
